import React from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_SOURCE_HOUSEHOLD_NOTES,
  DATA_TABLE_VIEW_ID_HOUSEHOLD_NOTES_ALL,
} from 'common/dataTableConstants';

import SrCard from 'client/components/SrCard/SrCard';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrCreateNoteForm, {
  SR_CREATE_NOTE_FORM_THEME_GREYCLIFF,
} from 'client/components/SrCreateNoteForm';
import SrNotesList, {
  SR_HOUSEHOLD_NOTES,
  SR_NOTES_LIST_THEME_GREYCLIFF,
} from 'client/components/SrNotesList';

const SrAdminHouseholdNotes = ({
  householdId,
  dispatch,
  currentUser,
  height,
}) => (
  <SrCard overflow='auto' height={height}>
    <SrText
      font='greycliff'
      fontSize='18px'
      weight='800'
      color='blueGreycliff'
      display='block'
      paddingBottom='20px'
    >
      Household Notes
    </SrText>
    <SrDataTableConnected
      itemsPropName='notes'
      dataSource={DATA_TABLE_SOURCE_HOUSEHOLD_NOTES}
      rootViewId={DATA_TABLE_VIEW_ID_HOUSEHOLD_NOTES_ALL}
      initialViewSettings={{
        sort: {
          createdDate: 'desc',
        },
        filter: {
          householdId,
        },
      }}
    >
      {({ notes, reloadItems, dataTableApiState, onInfiniteScrollWrapperRef }) => (
        <>
          <SrBox paddingBottom='10px'>
            <SrCreateNoteForm
              householdId={householdId}
              dispatch={dispatch}
              theme={SR_CREATE_NOTE_FORM_THEME_GREYCLIFF}
              reloadDataTable={(noteId) => {
                reloadItems({
                  count: 1,
                  filter: { 'householdNotes.id': noteId },
                });
              }}
            />
          </SrBox>
          <div ref={onInfiniteScrollWrapperRef}>
            <SrNotesList
              type={SR_HOUSEHOLD_NOTES}
              theme={SR_NOTES_LIST_THEME_GREYCLIFF}
              openedInModal
              notes={notes}
              dispatch={dispatch}
              reloadDataTable={(noteId) => {
                reloadItems({
                  count: 1,
                  filter: { 'householdNotes.id': noteId },
                });
              }}
              currentUser={currentUser}
            />
          </div>
          {dataTableApiState.inProgress && (
            <SrFlex justify='center'>
              <div className='loading-gif' />
            </SrFlex>
          )}
        </>
      )}
    </SrDataTableConnected>
  </SrCard>
);

SrAdminHouseholdNotes.propTypes = {
  householdId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
};

SrAdminHouseholdNotes.displayName = 'SrAdminHouseholdNotes';

export default SrAdminHouseholdNotes;
